export default __webpack_public_path__ + "static/media/Group 94.7816937c.png";